import * as dat from 'dat.gui';

// Detect currently loaded avatar name (mirrors avatar.js logic exactly)
const avatarAliases = { 'male': 'kevin', 'female': 'lisa', 'kevin-full-body': 'full-body-kevin', 'lisa-full-body': 'full-body-lisa' };
function getActiveAvatarName() {
    const pathSegment = window.location.pathname.replace(/^\//, '').split('/')[0].toLowerCase();
    const reservedPaths = ['models', 'voice', 'assets', 'public', 'avatar', 'avatars', 'talk', 'stop', 'config', ''];
    const rawName = (!reservedPaths.includes(pathSegment) && pathSegment) ? pathSegment : null;
    const avatarFromPath = rawName ? (avatarAliases[rawName] || rawName) : null;
    const urlParams = new URLSearchParams(window.location.search);
    const rawParam = urlParams.get('avatar');
    const avatarFromParam = rawParam ? (avatarAliases[rawParam.toLowerCase()] || rawParam.toLowerCase()) : null;
    return avatarFromPath || avatarFromParam || localStorage.getItem('avatar_name') || 'lisa';
}

// Resolve avatar config with baseAvatar inheritance
function resolveAvatarConfig(config, avatarName) {
    let c = config[avatarName];
    if (!c) return config.lisa || {};
    if (c.baseAvatar && config[c.baseAvatar]) {
        const { baseAvatar, ...overrides } = c;
        const base = config[baseAvatar];
        c = { ...base, ...overrides };
        // Deep merge nested objects so base properties aren't lost
        ['position', 'scale', 'rotation', 'lighting', 'morphTargets', 'animations'].forEach(key => {
            if (base[key] && typeof base[key] === 'object') {
                c[key] = overrides[key] ? { ...base[key], ...overrides[key] } : base[key];
            }
        });
    }
    return c;
}

// Lightweight API helper for controls (mirrors avatar.js approach)
const apiHelper = {
    post: (url, body = {}) => fetch(url, {
        method: 'POST',
        cache: 'no-store',
        headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache'
        },
        body: JSON.stringify(body),
        credentials: 'include'
    })
};

// Kevin avatar controls
const kevinParams = {
    rotX: -0.07, rotY: 1.10, rotZ: 0.07,
    posX: 21.30, posY: -9.60, posZ: 5.40,
    scaleX: 7.1, scaleY: 6.9, scaleZ: 6.5,
    camX: 35.2, camY: 2.5, camZ: 9.6
};

// Lisa avatar controls
const lisaParams = {
    rotX: 0, rotY: 1.3, rotZ: 0,
    posX: -7.9, posY: -15.7, posZ: -3.3,
    scaleX: 14, scaleY: 14, scaleZ: 8.7,
    camX: 35.2, camY: 2.5, camZ: 9.6
};

// Kevin lighting controls
const lightingParams = {
    // Key light
    keyIntensity: 1.3, keyColor: '#ffd6c2',
    keyPosX: 0.8, keyPosY: 1.6, keyPosZ: 2.2,
    // Fill light
    fillIntensity: 0.3, fillColor: '#fff2e8',
    fillPosX: -1.2, fillPosY: 1.2, fillPosZ: 1.6,
    // Rim light
    rimIntensity: 0.7, rimColor: '#ffe4d6',
    rimPosX: 0, rimPosY: 1.8, rimPosZ: -2.5,
    // Ambient
    ambientIntensity: 0.3, ambientColor: '#ffffff',
    // Chin fill
    chinIntensity: 1.8, chinColor: '#ffe8dc',
    chinPosX: 0, chinPosY: -0.5, chinPosZ: 1.8,
    // Tone mapping
    toneMappingExposure: 1.0,
    // HDR env map
    hdrEnvMapIntensity: 0.35,
    // Material overrides
    roughness: 0.45, metalness: 0.0, envMapIntensity: 0.35
};

// Lisa lighting controls
const lisaLightingParams = {
    // Key light
    keyIntensity: 2.6, keyColor: '#ffffff',
    keyPosX: 2, keyPosY: 3, keyPosZ: 2,
    // Fill light
    fillIntensity: 2.5, fillColor: '#ffffff',
    fillPosX: -2, fillPosY: 1.0, fillPosZ: 3,
    // Rim light
    rimIntensity: 3.5, rimColor: '#ffeedd',
    rimPosX: 0, rimPosY: 2, rimPosZ: -3,
    // Ambient
    ambientIntensity: 1.3, ambientColor: '#ffffff',
    // Tone mapping
    toneMappingExposure: 1.0,
    // HDR env map
    hdrEnvMapIntensity: 1.0,
    // Material overrides
    roughness: 0.5, metalness: 0.0, envMapIntensity: 1.0
};

// Event delegation for background upload
document.addEventListener('DOMContentLoaded', () => {
    const bgUpload = document.getElementById('bg-upload');
    if (bgUpload) {
        bgUpload.addEventListener('change', handleBackgroundUpload);
    }

    const resetBgBtn = document.getElementById('reset-bg-btn');
    if (resetBgBtn) {
        resetBgBtn.addEventListener('click', resetBackground);
    }

    // Position buttons
    document.querySelectorAll('.position-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
            const position = e.currentTarget.dataset.position;
            changeAvatarPosition(position);
        });
    });

    // Avatar buttons
    document.querySelectorAll('.avatar-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
            const avatar = e.currentTarget.dataset.avatar;
            switchAvatar(avatar);
        });
    });

    // Initialize Kevin dat.GUI controls
    //    initKevinDatGUI();

    // Initialize Lisa dat.GUI controls
    //    initLisaDatGUI();

});

function handleBackgroundUpload(event) {
    const file = event.target.files[0];
    if (!file) return;

    // Display file name
    const fileNameDiv = document.getElementById('file-name');
    fileNameDiv.textContent = `Selected: ${file.name}`;

    // Read and apply the image
    const reader = new FileReader();
    reader.onload = function (e) {
        const imageUrl = e.target.result;

        // Send message to avatar.js to change the Three.js scene background
        window.postMessage({
            type: 'CHANGE_BACKGROUND',
            data: { imageUrl: imageUrl }
        }, '*');

        // Store in localStorage for persistence
        localStorage.setItem('customBackground', imageUrl);
    };
    reader.readAsDataURL(file);
}

function resetBackground() {
    // Send message to avatar.js to reset background
    window.postMessage({
        type: 'RESET_BACKGROUND',
        data: {}
    }, '*');

    // Clear file input and name
    document.getElementById('bg-upload').value = '';
    document.getElementById('file-name').textContent = '';
}

function changeAvatarPosition(position) {
    // Remove active class from all buttons
    document.querySelectorAll('.position-btn').forEach(btn => {
        btn.classList.remove('active');
    });

    // Add active class to clicked button
    const activeBtn = document.getElementById(`btn-${position}`);
    if (activeBtn) {
        activeBtn.classList.add('active');
    }

    // Check which avatar is currently active
    const activeAvatarBtn = document.querySelector('.avatar-btn.active');
    let currentAvatar = 'lisa'; // default
    if (activeAvatarBtn) {
        const avatarId = activeAvatarBtn.id;
        currentAvatar = avatarId.replace('btn-', '');
    }

    // If Kevin is active and position is full/mid/head, use kevin-specific position
    if (currentAvatar === 'kevin' && ['full', 'mid', 'head'].includes(position)) {
        position = `kevin-${position}`;
    } else if (currentAvatar === 'kevin' && position === 'default') {
        position = 'kevin';
    }

    // Define camera positions for each view
    let cameraSettings = {};

    switch (position) {
        case 'default':
            cameraSettings = { x: 30.1, y: 1.85, z: 10.2 };
            break;
        case 'full':
            cameraSettings = { x: 36.2, y: 0.5, z: 12.5 };
            break;
        case 'mid':
            cameraSettings = { x: 27.2, y: 1.3, z: 8.85 };
            break;
        case 'head':
            cameraSettings = { x: 27.2, y: 2.8, z: 8 };
            break;
        case 'kevin':
            cameraSettings = { x: 30.1, y: 3, z: 10.2 };
            break;
        case 'kevin-full':
            cameraSettings = { x: 36.2, y: 0.5, z: 12.5 };
            break;
        case 'kevin-mid':
            cameraSettings = { x: 27.2, y: 3.3, z: 8.85 };
            break;
        case 'kevin-head':
            cameraSettings = { x: 27.2, y: 4.6, z: 9.25 };
            break;
    }

    // Send message to avatar.js to change camera position
    window.postMessage({
        type: 'CHANGE_CAMERA_POSITION',
        data: { position: position, camera: cameraSettings }
    }, '*');
}

function stopAvatar() {
    const button = document.getElementById('stop-button');
    if (button && button.disabled) return;

    if (button) {
        button.innerHTML = '<i class="fa-solid fa-microphone-slash"></i>';
        button.classList.remove('speaking');
        button.disabled = true;
    }

    window.postMessage({ type: 'STOP', data: {} }, '*');

    // API URL - Always same-origin to ensure session cookies are sent
    const API_URL = `${window.location.protocol}//${window.location.host}`;
    apiHelper.post(`${API_URL}/stop`)
        .catch(err => console.error('Stop request failed:', err));
}

function resetIconToDefault() {
    const button = document.getElementById('stop-button');
    if (button) {
        button.innerHTML = '<i class="fa-solid fa-microphone-slash"></i>';
        button.classList.remove('speaking');
        button.disabled = true;
    }
}

function enableStopButton() {
    const button = document.getElementById('stop-button');
    if (button) {
        button.innerHTML = '<i class="fa-solid fa-microphone"></i>';
        button.classList.add('speaking');
        button.disabled = false;
    }
}

window.resetIconToDefault = resetIconToDefault;
window.enableStopButton = enableStopButton;

async function switchAvatar(avatarName) {
    // Update UI immediately
    document.querySelectorAll('.avatar-btn').forEach(btn => {
        btn.classList.remove('active');
    });

    const activeBtn = document.getElementById(`btn-${avatarName}`);
    if (activeBtn) {
        activeBtn.classList.add('active');
    }

    try {
        // Get API URL - Always same-origin to ensure session cookies are sent
        const API_URL = `${window.location.protocol}//${window.location.host}`;

        // Call backend to switch avatar configuration
        console.log(`🔄 Switching to avatar: ${avatarName}`);
        const response = await apiHelper.post(`${API_URL}/switch-avatar`, { avatar: avatarName });

        if (!response.ok) {
            console.error(`Failed to switch avatar: ${response.status}`);
            throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();
        console.log('✅ Backend avatar switched:', data);

        // Send message to avatar.js to reload the model
        window.postMessage({
            type: 'SWITCH_AVATAR',
            data: { avatar: avatarName, avatarName: avatarName }
        }, '*');

        console.log(`✅ Avatar switched to ${avatarName}`);
    } catch (error) {
        console.error('Error switching avatar:', error);
        alert(`Failed to switch to ${avatarName}. Please try again.`);
    }
}

function initKevinDatGUI() {
    fetch('/config/avatars.json')
        .then(r => r.json())
        .then(config => {
            const k = config.kevin;
            kevinParams.rotX = k.rotation.x; kevinParams.rotY = k.rotation.y; kevinParams.rotZ = k.rotation.z;
            kevinParams.posX = k.position.x; kevinParams.posY = k.position.y; kevinParams.posZ = k.position.z;
            kevinParams.scaleX = k.scale.x; kevinParams.scaleY = k.scale.y; kevinParams.scaleZ = k.scale.z;
            // Load lighting params
            const lc = k.lighting || {};
            if (lc.keyLight) {
                lightingParams.keyIntensity = lc.keyLight.intensity ?? lightingParams.keyIntensity;
                lightingParams.keyColor = lc.keyLight.color ?? lightingParams.keyColor;
                if (lc.keyLight.position) { lightingParams.keyPosX = lc.keyLight.position.x; lightingParams.keyPosY = lc.keyLight.position.y; lightingParams.keyPosZ = lc.keyLight.position.z; }
            }
            if (lc.fillLight) {
                lightingParams.fillIntensity = lc.fillLight.intensity ?? lightingParams.fillIntensity;
                lightingParams.fillColor = lc.fillLight.color ?? lightingParams.fillColor;
                if (lc.fillLight.position) { lightingParams.fillPosX = lc.fillLight.position.x; lightingParams.fillPosY = lc.fillLight.position.y; lightingParams.fillPosZ = lc.fillLight.position.z; }
            }
            if (lc.rimLight) {
                lightingParams.rimIntensity = lc.rimLight.intensity ?? lightingParams.rimIntensity;
                lightingParams.rimColor = lc.rimLight.color ?? lightingParams.rimColor;
                if (lc.rimLight.position) { lightingParams.rimPosX = lc.rimLight.position.x; lightingParams.rimPosY = lc.rimLight.position.y; lightingParams.rimPosZ = lc.rimLight.position.z; }
            }
            if (lc.ambient) {
                lightingParams.ambientIntensity = lc.ambient.intensity ?? lightingParams.ambientIntensity;
                lightingParams.ambientColor = lc.ambient.color ?? lightingParams.ambientColor;
            }
            if (lc.toneMappingExposure != null) lightingParams.toneMappingExposure = lc.toneMappingExposure;
            if (lc.hdrEnvMap) lightingParams.hdrEnvMapIntensity = lc.hdrEnvMap.intensity ?? lightingParams.hdrEnvMapIntensity;
            const cl = k.chinFillLight;
            if (cl) {
                lightingParams.chinIntensity = cl.intensity ?? lightingParams.chinIntensity;
                lightingParams.chinColor = cl.color ?? lightingParams.chinColor;
                if (cl.position) { lightingParams.chinPosX = cl.position.x; lightingParams.chinPosY = cl.position.y; lightingParams.chinPosZ = cl.position.z; }
            }
            const mo = k.materialOverrides;
            if (mo) {
                lightingParams.roughness = mo.roughness ?? lightingParams.roughness;
                lightingParams.metalness = mo.metalness ?? lightingParams.metalness;
                lightingParams.envMapIntensity = mo.envMapIntensity ?? lightingParams.envMapIntensity;
            }
            buildDatGUI();
        })
        .catch(() => buildDatGUI());
}

function buildDatGUI() {
    const gui = new dat.GUI({ name: 'Kevin Controls' });
    window.__kevinGUI = gui;

    const rotFolder = gui.addFolder('Rotation');
    rotFolder.add(kevinParams, 'rotX', -3.14, 3.14, 0.01).name('X').onChange(applyTransform);
    rotFolder.add(kevinParams, 'rotY', -3.14, 3.14, 0.01).name('Y').onChange(applyTransform);
    rotFolder.add(kevinParams, 'rotZ', -3.14, 3.14, 0.01).name('Z').onChange(applyTransform);
    rotFolder.open();

    const posFolder = gui.addFolder('Position');
    posFolder.add(kevinParams, 'posX', -50, 50, 0.1).name('X').onChange(applyTransform);
    posFolder.add(kevinParams, 'posY', -50, 50, 0.1).name('Y').onChange(applyTransform);
    posFolder.add(kevinParams, 'posZ', -50, 50, 0.1).name('Z').onChange(applyTransform);
    posFolder.open();

    const scaleFolder = gui.addFolder('Scale');
    scaleFolder.add(kevinParams, 'scaleX', 1, 20, 0.1).name('X').onChange(applyTransform);
    scaleFolder.add(kevinParams, 'scaleY', 1, 20, 0.1).name('Y').onChange(applyTransform);
    scaleFolder.add(kevinParams, 'scaleZ', 1, 20, 0.1).name('Z').onChange(applyTransform);
    scaleFolder.open();

    const camFolder = gui.addFolder('Camera Position');
    camFolder.add(kevinParams, 'camX', 0, 60, 0.1).name('X').onChange(applyCamera);
    camFolder.add(kevinParams, 'camY', -10, 20, 0.1).name('Y').onChange(applyCamera);
    camFolder.add(kevinParams, 'camZ', 0, 30, 0.1).name('Z').onChange(applyCamera);
    camFolder.open();

    gui.add({ reset: resetKevinParams }, 'reset').name('Reset All');

    // === LIGHTING CONTROLS ===
    const keyFolder = gui.addFolder('Key Light');
    keyFolder.add(lightingParams, 'keyIntensity', 0, 5, 0.1).name('Intensity').onChange(applyLighting);
    keyFolder.addColor(lightingParams, 'keyColor').name('Color').onChange(applyLighting);
    keyFolder.add(lightingParams, 'keyPosX', -5, 5, 0.1).name('Pos X').onChange(applyLighting);
    keyFolder.add(lightingParams, 'keyPosY', -5, 5, 0.1).name('Pos Y').onChange(applyLighting);
    keyFolder.add(lightingParams, 'keyPosZ', -5, 5, 0.1).name('Pos Z').onChange(applyLighting);

    const fillFolder = gui.addFolder('Fill Light');
    fillFolder.add(lightingParams, 'fillIntensity', 0, 5, 0.1).name('Intensity').onChange(applyLighting);
    fillFolder.addColor(lightingParams, 'fillColor').name('Color').onChange(applyLighting);
    fillFolder.add(lightingParams, 'fillPosX', -5, 5, 0.1).name('Pos X').onChange(applyLighting);
    fillFolder.add(lightingParams, 'fillPosY', -5, 5, 0.1).name('Pos Y').onChange(applyLighting);
    fillFolder.add(lightingParams, 'fillPosZ', -5, 5, 0.1).name('Pos Z').onChange(applyLighting);

    const rimFolder = gui.addFolder('Rim Light');
    rimFolder.add(lightingParams, 'rimIntensity', 0, 5, 0.1).name('Intensity').onChange(applyLighting);
    rimFolder.addColor(lightingParams, 'rimColor').name('Color').onChange(applyLighting);
    rimFolder.add(lightingParams, 'rimPosX', -5, 5, 0.1).name('Pos X').onChange(applyLighting);
    rimFolder.add(lightingParams, 'rimPosY', -5, 5, 0.1).name('Pos Y').onChange(applyLighting);
    rimFolder.add(lightingParams, 'rimPosZ', -5, 5, 0.1).name('Pos Z').onChange(applyLighting);

    const ambientFolder = gui.addFolder('Ambient Light');
    ambientFolder.add(lightingParams, 'ambientIntensity', 0, 3, 0.05).name('Intensity').onChange(applyLighting);
    ambientFolder.addColor(lightingParams, 'ambientColor').name('Color').onChange(applyLighting);

    const chinFolder = gui.addFolder('Chin Fill Light');
    chinFolder.add(lightingParams, 'chinIntensity', 0, 5, 0.1).name('Intensity').onChange(applyLighting);
    chinFolder.addColor(lightingParams, 'chinColor').name('Color').onChange(applyLighting);
    chinFolder.add(lightingParams, 'chinPosX', -5, 5, 0.1).name('Pos X').onChange(applyLighting);
    chinFolder.add(lightingParams, 'chinPosY', -5, 5, 0.1).name('Pos Y').onChange(applyLighting);
    chinFolder.add(lightingParams, 'chinPosZ', -5, 5, 0.1).name('Pos Z').onChange(applyLighting);

    const toneFolder = gui.addFolder('Tone Mapping');
    toneFolder.add(lightingParams, 'toneMappingExposure', 0, 3, 0.05).name('Exposure').onChange(applyLighting);
    toneFolder.add(lightingParams, 'hdrEnvMapIntensity', 0, 2, 0.05).name('HDR Intensity').onChange(applyLighting);

    const matFolder = gui.addFolder('Material Overrides');
    matFolder.add(lightingParams, 'roughness', 0, 1, 0.05).name('Roughness').onChange(applyLighting);
    matFolder.add(lightingParams, 'metalness', 0, 1, 0.05).name('Metalness').onChange(applyLighting);
    matFolder.add(lightingParams, 'envMapIntensity', 0, 2, 0.05).name('EnvMap Intensity').onChange(applyLighting);

    gui.add({ logLighting: () => console.log(JSON.stringify(lightingParams, null, 2)) }, 'logLighting').name('Log Lighting Values');
}

function applyTransform() {
    window.postMessage({
        type: 'UPDATE_TRANSFORM',
        data: {
            rotation: { x: kevinParams.rotX, y: kevinParams.rotY, z: kevinParams.rotZ },
            position: { x: kevinParams.posX, y: kevinParams.posY, z: kevinParams.posZ },
            scale: { x: kevinParams.scaleX, y: kevinParams.scaleY, z: kevinParams.scaleZ }
        }
    }, '*');
}

function applyCamera() {
    window.postMessage({
        type: 'CHANGE_CAMERA_POSITION',
        data: { camera: { x: kevinParams.camX, y: kevinParams.camY, z: kevinParams.camZ } }
    }, '*');
}

function applyLighting() {
    window.postMessage({
        type: 'UPDATE_LIGHTING',
        data: {
            keyLight: {
                intensity: lightingParams.keyIntensity,
                color: lightingParams.keyColor,
                position: { x: lightingParams.keyPosX, y: lightingParams.keyPosY, z: lightingParams.keyPosZ }
            },
            fillLight: {
                intensity: lightingParams.fillIntensity,
                color: lightingParams.fillColor,
                position: { x: lightingParams.fillPosX, y: lightingParams.fillPosY, z: lightingParams.fillPosZ }
            },
            rimLight: {
                intensity: lightingParams.rimIntensity,
                color: lightingParams.rimColor,
                position: { x: lightingParams.rimPosX, y: lightingParams.rimPosY, z: lightingParams.rimPosZ }
            },
            ambient: {
                intensity: lightingParams.ambientIntensity,
                color: lightingParams.ambientColor
            },
            chinFillLight: {
                intensity: lightingParams.chinIntensity,
                color: lightingParams.chinColor,
                position: { x: lightingParams.chinPosX, y: lightingParams.chinPosY, z: lightingParams.chinPosZ }
            },
            toneMappingExposure: lightingParams.toneMappingExposure,
            hdrEnvMapIntensity: lightingParams.hdrEnvMapIntensity,
            materialOverrides: {
                roughness: lightingParams.roughness,
                metalness: lightingParams.metalness,
                envMapIntensity: lightingParams.envMapIntensity
            }
        }
    }, '*');
}

function resetKevinParams() {
    fetch('/config/avatars.json')
        .then(r => r.json())
        .then(config => {
            const k = config.kevin;
            kevinParams.rotX = k.rotation.x; kevinParams.rotY = k.rotation.y; kevinParams.rotZ = k.rotation.z;
            kevinParams.posX = k.position.x; kevinParams.posY = k.position.y; kevinParams.posZ = k.position.z;
            kevinParams.scaleX = k.scale.x; kevinParams.scaleY = k.scale.y; kevinParams.scaleZ = k.scale.z;
            if (window.__kevinGUI) {
                Object.values(window.__kevinGUI.__folders).forEach(folder =>
                    folder.__controllers.forEach(c => c.updateDisplay())
                );
            }
            applyTransform();
        });
    kevinParams.camX = 35.2; kevinParams.camY = 2.5; kevinParams.camZ = 9.6;
    applyCamera();
}

// ==================== LISA DAT.GUI CONTROLS ====================

function initLisaDatGUI() {
    fetch('/config/avatars.json')
        .then(r => r.json())
        .then(config => {
            // Read whichever avatar is actually loaded (matches avatar.js detection)
            const activeAvatar = getActiveAvatarName();
            const l = resolveAvatarConfig(config, activeAvatar);
            console.log(`🎛️ Lisa GUI loading config for: ${activeAvatar}`);

            lisaParams.rotX = l.rotation.x; lisaParams.rotY = l.rotation.y; lisaParams.rotZ = l.rotation.z;
            lisaParams.posX = l.position.x; lisaParams.posY = l.position.y; lisaParams.posZ = l.position.z;
            lisaParams.scaleX = l.scale.x; lisaParams.scaleY = l.scale.y; lisaParams.scaleZ = l.scale.z;
            // Load lighting params
            const lc = l.lighting || {};
            if (lc.keyLight) {
                lisaLightingParams.keyIntensity = lc.keyLight.intensity ?? lisaLightingParams.keyIntensity;
                lisaLightingParams.keyColor = lc.keyLight.color ?? lisaLightingParams.keyColor;
                if (lc.keyLight.position) { lisaLightingParams.keyPosX = lc.keyLight.position.x; lisaLightingParams.keyPosY = lc.keyLight.position.y; lisaLightingParams.keyPosZ = lc.keyLight.position.z; }
            }
            if (lc.fillLight) {
                lisaLightingParams.fillIntensity = lc.fillLight.intensity ?? lisaLightingParams.fillIntensity;
                lisaLightingParams.fillColor = lc.fillLight.color ?? lisaLightingParams.fillColor;
                if (lc.fillLight.position) { lisaLightingParams.fillPosX = lc.fillLight.position.x; lisaLightingParams.fillPosY = lc.fillLight.position.y; lisaLightingParams.fillPosZ = lc.fillLight.position.z; }
            }
            if (lc.rimLight) {
                lisaLightingParams.rimIntensity = lc.rimLight.intensity ?? lisaLightingParams.rimIntensity;
                lisaLightingParams.rimColor = lc.rimLight.color ?? lisaLightingParams.rimColor;
                if (lc.rimLight.position) { lisaLightingParams.rimPosX = lc.rimLight.position.x; lisaLightingParams.rimPosY = lc.rimLight.position.y; lisaLightingParams.rimPosZ = lc.rimLight.position.z; }
            }
            if (lc.ambient) {
                lisaLightingParams.ambientIntensity = lc.ambient.intensity ?? lisaLightingParams.ambientIntensity;
                lisaLightingParams.ambientColor = lc.ambient.color ?? lisaLightingParams.ambientColor;
            }
            if (lc.toneMappingExposure != null) lisaLightingParams.toneMappingExposure = lc.toneMappingExposure;
            if (lc.hdrEnvMap) lisaLightingParams.hdrEnvMapIntensity = lc.hdrEnvMap.intensity ?? lisaLightingParams.hdrEnvMapIntensity;
            const mo = l.materialOverrides;
            if (mo) {
                lisaLightingParams.roughness = mo.roughness ?? lisaLightingParams.roughness;
                lisaLightingParams.metalness = mo.metalness ?? lisaLightingParams.metalness;
                lisaLightingParams.envMapIntensity = mo.envMapIntensity ?? lisaLightingParams.envMapIntensity;
            }
            buildLisaDatGUI();
        })
        .catch(() => buildLisaDatGUI());
}

function buildLisaDatGUI() {
    const gui = new dat.GUI({ name: 'Lisa Controls' });
    window.__lisaGUI = gui;

    const rotFolder = gui.addFolder('Rotation');
    rotFolder.add(lisaParams, 'rotX', -3.14, 3.14, 0.01).name('X').onChange(applyLisaTransform);
    rotFolder.add(lisaParams, 'rotY', -3.14, 3.14, 0.01).name('Y').onChange(applyLisaTransform);
    rotFolder.add(lisaParams, 'rotZ', -3.14, 3.14, 0.01).name('Z').onChange(applyLisaTransform);
    rotFolder.open();

    const posFolder = gui.addFolder('Position');
    posFolder.add(lisaParams, 'posX', -50, 50, 0.1).name('X').onChange(applyLisaTransform);
    posFolder.add(lisaParams, 'posY', -50, 50, 0.1).name('Y').onChange(applyLisaTransform);
    posFolder.add(lisaParams, 'posZ', -50, 50, 0.1).name('Z').onChange(applyLisaTransform);
    posFolder.open();

    const scaleFolder = gui.addFolder('Scale');
    scaleFolder.add(lisaParams, 'scaleX', 1, 20, 0.1).name('X').onChange(applyLisaTransform);
    scaleFolder.add(lisaParams, 'scaleY', 1, 20, 0.1).name('Y').onChange(applyLisaTransform);
    scaleFolder.add(lisaParams, 'scaleZ', 1, 20, 0.1).name('Z').onChange(applyLisaTransform);
    scaleFolder.open();

    const camFolder = gui.addFolder('Camera Position');
    camFolder.add(lisaParams, 'camX', 0, 60, 0.1).name('X').onChange(applyLisaCamera);
    camFolder.add(lisaParams, 'camY', -10, 20, 0.1).name('Y').onChange(applyLisaCamera);
    camFolder.add(lisaParams, 'camZ', 0, 30, 0.1).name('Z').onChange(applyLisaCamera);
    camFolder.open();

    gui.add({ reset: resetLisaParams }, 'reset').name('Reset All');

    // === LIGHTING CONTROLS ===
    const keyFolder = gui.addFolder('Key Light');
    keyFolder.add(lisaLightingParams, 'keyIntensity', 0, 5, 0.1).name('Intensity').onChange(applyLisaLighting);
    keyFolder.addColor(lisaLightingParams, 'keyColor').name('Color').onChange(applyLisaLighting);
    keyFolder.add(lisaLightingParams, 'keyPosX', -5, 5, 0.1).name('Pos X').onChange(applyLisaLighting);
    keyFolder.add(lisaLightingParams, 'keyPosY', -5, 5, 0.1).name('Pos Y').onChange(applyLisaLighting);
    keyFolder.add(lisaLightingParams, 'keyPosZ', -5, 5, 0.1).name('Pos Z').onChange(applyLisaLighting);

    const fillFolder = gui.addFolder('Fill Light');
    fillFolder.add(lisaLightingParams, 'fillIntensity', 0, 5, 0.1).name('Intensity').onChange(applyLisaLighting);
    fillFolder.addColor(lisaLightingParams, 'fillColor').name('Color').onChange(applyLisaLighting);
    fillFolder.add(lisaLightingParams, 'fillPosX', -5, 5, 0.1).name('Pos X').onChange(applyLisaLighting);
    fillFolder.add(lisaLightingParams, 'fillPosY', -5, 5, 0.1).name('Pos Y').onChange(applyLisaLighting);
    fillFolder.add(lisaLightingParams, 'fillPosZ', -5, 5, 0.1).name('Pos Z').onChange(applyLisaLighting);

    const rimFolder = gui.addFolder('Rim Light');
    rimFolder.add(lisaLightingParams, 'rimIntensity', 0, 5, 0.1).name('Intensity').onChange(applyLisaLighting);
    rimFolder.addColor(lisaLightingParams, 'rimColor').name('Color').onChange(applyLisaLighting);
    rimFolder.add(lisaLightingParams, 'rimPosX', -5, 5, 0.1).name('Pos X').onChange(applyLisaLighting);
    rimFolder.add(lisaLightingParams, 'rimPosY', -5, 5, 0.1).name('Pos Y').onChange(applyLisaLighting);
    rimFolder.add(lisaLightingParams, 'rimPosZ', -5, 5, 0.1).name('Pos Z').onChange(applyLisaLighting);

    const ambientFolder = gui.addFolder('Ambient Light');
    ambientFolder.add(lisaLightingParams, 'ambientIntensity', 0, 3, 0.05).name('Intensity').onChange(applyLisaLighting);
    ambientFolder.addColor(lisaLightingParams, 'ambientColor').name('Color').onChange(applyLisaLighting);

    const toneFolder = gui.addFolder('Tone Mapping');
    toneFolder.add(lisaLightingParams, 'toneMappingExposure', 0, 3, 0.05).name('Exposure').onChange(applyLisaLighting);
    toneFolder.add(lisaLightingParams, 'hdrEnvMapIntensity', 0, 2, 0.05).name('HDR Intensity').onChange(applyLisaLighting);

    const matFolder = gui.addFolder('Material Overrides');
    matFolder.add(lisaLightingParams, 'roughness', 0, 1, 0.05).name('Roughness').onChange(applyLisaLighting);
    matFolder.add(lisaLightingParams, 'metalness', 0, 1, 0.05).name('Metalness').onChange(applyLisaLighting);
    matFolder.add(lisaLightingParams, 'envMapIntensity', 0, 2, 0.05).name('EnvMap Intensity').onChange(applyLisaLighting);

    gui.add({ logLighting: () => console.log(JSON.stringify(lisaLightingParams, null, 2)) }, 'logLighting').name('Log Lighting Values');
}

function applyLisaTransform() {
    window.postMessage({
        type: 'UPDATE_TRANSFORM',
        data: {
            rotation: { x: lisaParams.rotX, y: lisaParams.rotY, z: lisaParams.rotZ },
            position: { x: lisaParams.posX, y: lisaParams.posY, z: lisaParams.posZ },
            scale: { x: lisaParams.scaleX, y: lisaParams.scaleY, z: lisaParams.scaleZ }
        }
    }, '*');
}

function applyLisaCamera() {
    window.postMessage({
        type: 'CHANGE_CAMERA_POSITION',
        data: { camera: { x: lisaParams.camX, y: lisaParams.camY, z: lisaParams.camZ } }
    }, '*');
}

function applyLisaLighting() {
    window.postMessage({
        type: 'UPDATE_LIGHTING',
        data: {
            keyLight: {
                intensity: lisaLightingParams.keyIntensity,
                color: lisaLightingParams.keyColor,
                position: { x: lisaLightingParams.keyPosX, y: lisaLightingParams.keyPosY, z: lisaLightingParams.keyPosZ }
            },
            fillLight: {
                intensity: lisaLightingParams.fillIntensity,
                color: lisaLightingParams.fillColor,
                position: { x: lisaLightingParams.fillPosX, y: lisaLightingParams.fillPosY, z: lisaLightingParams.fillPosZ }
            },
            rimLight: {
                intensity: lisaLightingParams.rimIntensity,
                color: lisaLightingParams.rimColor,
                position: { x: lisaLightingParams.rimPosX, y: lisaLightingParams.rimPosY, z: lisaLightingParams.rimPosZ }
            },
            ambient: {
                intensity: lisaLightingParams.ambientIntensity,
                color: lisaLightingParams.ambientColor
            },
            toneMappingExposure: lisaLightingParams.toneMappingExposure,
            hdrEnvMapIntensity: lisaLightingParams.hdrEnvMapIntensity,
            materialOverrides: {
                roughness: lisaLightingParams.roughness,
                metalness: lisaLightingParams.metalness,
                envMapIntensity: lisaLightingParams.envMapIntensity
            }
        }
    }, '*');
}

function resetLisaParams() {
    fetch('/config/avatars.json')
        .then(r => r.json())
        .then(config => {
            const activeAvatar = getActiveAvatarName();
            const l = resolveAvatarConfig(config, activeAvatar);
            lisaParams.rotX = l.rotation.x; lisaParams.rotY = l.rotation.y; lisaParams.rotZ = l.rotation.z;
            lisaParams.posX = l.position.x; lisaParams.posY = l.position.y; lisaParams.posZ = l.position.z;
            lisaParams.scaleX = l.scale.x; lisaParams.scaleY = l.scale.y; lisaParams.scaleZ = l.scale.z;
            if (window.__lisaGUI) {
                Object.values(window.__lisaGUI.__folders).forEach(folder =>
                    folder.__controllers.forEach(c => c.updateDisplay())
                );
            }
            applyLisaTransform();
        });
    lisaParams.camX = 35.2; lisaParams.camY = 2.5; lisaParams.camZ = 9.6;
    applyLisaCamera();
}

export { handleBackgroundUpload, resetBackground, changeAvatarPosition, switchAvatar, stopAvatar };
